import React, { useCallback, useEffect, useState } from 'react';

import Accordion from 'b2b-ui-components-lib/lib/components/accordion';
import { FormBuilder } from 'featureLib/FormBuilder';

import { checkOrderConfirmationStatusPending, getVisibleFormFields, trackAnalytics } from 'common/utils/app.utils';
import { isFormValid as isFormValidUtility } from 'featureLib/FormBuilder/form.validator';
import { getCurrentOrder } from 'tokenGeneration/lead.util';
import './index.scss';

const CPMDetailsComponent = ({ accordionMeta, setAccordionMeta, cpmFormSchema, setCpmFormSchema, isOrderConfirmation }) => {
  const [details, setDetails] = useState(null);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');

  const handleFormFieldChange = ({ field, value, oldValue, newValue, form }) => {
    handleAccordionValidation(form);
  };

  const onFormFieldChange = useCallback((field, value, initialState, { setForm, form, disableAll, oldValue, newValue }) => {
    handleFormFieldChange({ form, field, value, oldValue, newValue });
  }, []);

  const onFormSubmit = useCallback((form) => {
    setCpmFormSchema(form.values);
  }, []);

  const handleAccordionValidation = (form) => {
    const visibleFields = getVisibleFormFields({ ...form });
    const isFormValid = isFormValidUtility(visibleFields);

    if (isFormValid) {
      setAccordionMeta({
        isExpanded: true,
        isValidated: true
      });
    } else {
      setAccordionMeta({
        isExpanded: true,
        isValidated: false
      });
    }
  };

  const setDefaultFormData = () => {
    const savedOrder = getCurrentOrder?.();
    let cpmFormSchemaCpy = { ...cpmFormSchema };
    cpmFormSchemaCpy = {
      ...cpmFormSchemaCpy,
      name: {
        ...cpmFormSchemaCpy.name,
        value: savedOrder?.customerProjectManagerDetails?.name,
        disabled: isOrderConfirmation || checkOrderConfirmationStatusPending()
      },
      mobileNumber: {
        ...cpmFormSchemaCpy.mobileNumber,
        value: savedOrder?.customerProjectManagerDetails?.contactNumber,
        disabled: isOrderConfirmation || checkOrderConfirmationStatusPending()
      },
      emailAddress: {
        ...cpmFormSchemaCpy.emailAddress,
        value: savedOrder?.customerProjectManagerDetails?.emailId,
        disabled: isOrderConfirmation || checkOrderConfirmationStatusPending()
      }
    };

    setCpmFormSchema(cpmFormSchemaCpy);
    handleAccordionValidation(cpmFormSchemaCpy);
  };

  useEffect(() => {
    setDefaultFormData();
    const data = getCurrentOrder();
    setDetails(data);
    console.log('THIS');
    trackAnalytics({
      eVar0: `b2b|${data?.serviceType}|buy|confirm installations`,
      prop0: `b2b|${data?.lead?.customer?.segment}|${data?.serviceType}`,
      prop15: data?.customerEmail || '',
      prop17: `${data?.lead?.customer?.authorizedSignatory?.firstName || ''} ${data?.lead?.customer?.authorizedSignatory?.lastName || ''}`,
      prop14: data?.lead?.customer?.authorizedSignatory?.phoneNumber || '',
      prop35: data?.companyAddress?.officeName || '',
      prop39: data?.lead?.customer?.segment || '',
      prop40: data?.serviceType || '',
      prop37: data?.orderType || '',
      // prop41=<type of site>
      // Prop43=<no. of sites>
      prop21: data?.lead?.connectivityLineItems?.[0]?.feasibilityId || '', //feasibility request id
      // Prop23=<link id>
      prop9: data?.companyAddress?.pincode || '',
      prop36: data?.companyAddress?.officeName || '',
      prop20: data?.companyAddress?.addressLine1 || '',
      prop26: data?.lead?.connectivityLineItems?.[0]?.planDetail?.speed || '',
      // Prop28=<site type>
      prop10: data?.orderId || '',
      prop29: data?.lead?.connectivityLineItems?.[0]?.selectedMedia?.[0]?.media || '',
      prop22: data?.lead?.connectivityLineItems?.[0]?.planDetail?.planPeriod || '',
      prop18: data?.lead?.planDetail?.totalPrice || '',
      prop1: data?.purchaseOrder?.poNumber || '',
      prop24: data?.documents?.PURCHASE_ORDER?.PO_DOCUMENT || '',
      prop25: data?.purchaseOrder?.purchaseOrderDate || '',
      prop2: data?.purchaseOrder?.poAmount || '',
      prop3: data?.billingType || '',
      prop4: data?.billingCycle || '',
      prop5: data?.lead?.customer?.panNumber || '',
      prop16: data?.companyAddress?.city || '',
      prop7: data?.siteIncharge?.firstName || '',
      prop8: data?.siteIncharge?.phoneNumber || '',
      prop9: data?.siteIncharge?.email || '',
      prop37: data?.lead?.connectivityLineItems?.[0]?.customerNeedDate || '',
      prop38: data?.fiscalCode?.id || ''
      // Prop11=<full name of CPM>
      // Prop12=<mobile number of CPM>
      // Prop13=<email address of CPM>
    });
  }, [isOrderConfirmation]);

  const sendAnalytics = (a, data) => {
    // data.key === "name" && setName(data.value)
    // data.key === "emailAddress" && setEmail(data.value)
    // data.key === "mobileNumber" && setPhone(data.value)

    trackAnalytics({
      eVar0: `b2b|${details?.serviceType}|buy|confirm installations|${data.key}`,
      prop0: `b2b|${details?.lead?.customer?.segment}|${details?.serviceType}`,
      prop15: details?.customerEmail || '',
      prop17: `${details?.lead?.customer?.authorizedSignatory?.firstName || ''} ${details?.lead?.customer?.authorizedSignatory?.lastName || ''}`,
      prop14: details?.lead?.customer?.authorizedSignatory?.phoneNumber || '',
      prop35: details?.companyAddress?.officeName || '',
      prop39: details?.lead?.customer?.segment || '',
      prop40: details?.serviceType || '',
      prop37: details?.orderType || '',
      // prop41=<type of site>
      // Prop43=<no. of sites>
      prop21: details?.lead?.connectivityLineItems?.[0]?.feasibilityId || '', //feasibility request id
      // Prop23=<link id>
      prop9: details?.companyAddress?.pincode || '',
      prop36: details?.companyAddress?.officeName || '',
      prop20: details?.companyAddress?.addressLine1 || '',
      prop26: details?.lead?.connectivityLineItems?.[0]?.planDetail?.speed || '',
      // Prop28=<site type>
      prop10: details?.orderId || '',
      prop29: details?.lead?.connectivityLineItems?.[0]?.selectedMedia?.[0]?.media || '',
      prop22: details?.lead?.connectivityLineItems?.[0]?.planDetail?.planPeriod || '',
      prop18: details?.lead?.planDetail?.totalPrice || '',
      prop1: details?.purchaseOrder?.poNumber || '',
      prop24: details?.documents?.PURCHASE_ORDER?.PO_DOCUMENT || '',
      prop25: details?.purchaseOrder?.purchaseOrderDate || '',
      prop2: details?.purchaseOrder?.poAmount || '',
      prop3: details?.billingType || '',
      prop4: details?.billingCycle || '',
      prop5: details?.lead?.customer?.panNumber || '',
      prop16: details?.companyAddress?.city || '',
      prop7: data.key === 'name' ? data.value : '',
      prop8: data.key === 'mobileNumber' ? data.value : '',
      prop9: data.key === 'emailAddress' ? data.value : '',
      prop37: details?.lead?.connectivityLineItems?.[0]?.customerNeedDate || '',
      prop38: details?.fiscalCode?.id || ''
      // Prop11=<full name of CPM>
      // Prop12=<mobile number of CPM>
      // Prop13=<email address of CPM>
    });
  };
  return (
    <div className="cpm_details">
      <Accordion
        title={<div>Company Project Manager</div>}
        isExpanded={accordionMeta.isExpanded}
        isValidated={accordionMeta.isValidated}
        autoScrollOnExpand={false}
        variant="round"
      >
        <div className="form_section">
          <div className="row">
            <FormBuilder formConfig={cpmFormSchema} onChange={onFormFieldChange} onFieldBlurFn={sendAnalytics} onSubmit={onFormSubmit}></FormBuilder>
          </div>
        </div>
      </Accordion>
    </div>
  );
};

export default CPMDetailsComponent;
